import load from 'react-loadable'

const Loadable = (loader, options) =>
  load({
    loader,
    loading: () => null,
    timeout: 10000,
    delay: 500,
    ...options
  })

export default Loadable
